import {
  Center,
  Paper,
  Stack,
  Title,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { IconShieldX } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// -----------------------------------------------------------------------------
export const UnauthorizedPage: FC = () => {
  const { t } = useTranslation(['status-pages']);
  const theme = useMantineTheme();

  // ---------------------------------------------------------------------------
  return (
    <Center h="100%">
      <Paper p="xl" radius="lg" shadow="xl">
        <Stack justify="center" align="center" gap="lg">
          <IconShieldX size={64} color={theme.colors.red[7]} />
          <Stack justify="center" align="center" gap="4px">
            <Title m="0">
              {t('unauthorized.title', { ns: 'status-pages' })}
            </Title>
            <Text>{t('unauthorized.description', { ns: 'status-pages' })}</Text>
          </Stack>
        </Stack>
      </Paper>
    </Center>
  );
};
